// import useTickers from "./useTickers"
import useSWR from "swr"
import { useCallback, useEffect, useMemo, useState } from "react"

export default function useFinancial(ticker) {
    const [FinanicalKPICategory, setFinanicalKPICategory] = useState(["All"])
    // const { checkPrivateCompany } = useTickers()
    const { data } = useSWR(`/api/financialInfo?ticker=${ticker}`)
    const { data:nonGaapData } = useSWR(ticker && `/api/financialInfoNonGaapKPI?ticker=${ticker}`)

    // const privateCompany = useMemo(()=> checkPrivateCompany(ticker),[ticker, checkPrivateCompany])

    const initialOptions = useMemo(() => {
        // if(privateCompany === undefined && !data) { return privateCompany }
        // return data?.filter(financialInfo => privateCompany === !!financialInfo.private )
        return data?.filter(financialInfo =>!financialInfo.private==true)
    // },[privateCompany, data])
    },[data])

    const suggested = initialOptions?.length && initialOptions.find(t => t.suggested === true).value

    const options = useMemo(()=> initialOptions && nonGaapData ? [...nonGaapData, ...initialOptions] : null
    , [initialOptions, nonGaapData])

    const getFinancialNameByValue = useCallback((value) => {
        const result =  options?.find(t => t.value === value) || data?.find(t => t.value === value)
        return result && result.name
    },[options, data])

    useEffect(() =>{
        if (initialOptions?.length > 0){
            const temp = ['All']
            const uniqueCategories = [...new Set(initialOptions.map(item => item.category))];
            setFinanicalKPICategory([...temp, ...uniqueCategories])
        }
        return () => {}
    },[initialOptions])

    const getFinancialDataFrequency = (financialData) => ['stockPrice', 'volume'].includes(financialData) ? 'daily' : 'quarterly'

    return {
        options,
        suggested,
        FinanicalKPICategory,
        getFinancialNameByValue,
        getFinancialDataFrequency
    }
}